import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Login from '@/views/Login/index.vue'

import PlanList from '@/views/Plan/list.vue'
import studentList from '@/views/Plan/studentList.vue'
import recheckList from '@/views/Plan/recheckList.vue'
import recheckList1 from '@/views/Plan/recheckList1.vue'
import abnormalStudentList from '@/views/Plan/abnormalStudentList.vue'
import archiveList from '@/views/Archive/index.vue'
import Home from '@/views/Home/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: '首页',
    component: Home,
    meta: {
      title: 'Home'
    },
    children: [
      {
        path: '/archive',
        name: '档案查询',
        component: archiveList,
      },
    ]
  },
  {
    path: '/planList',
    name: 'list',
    component: PlanList
  },
  {
    path: '/studentList',
    name: 'studentList',
    component: studentList
  },
  {
    path: '/recheckList',
    name: 'recheckList',
    component: recheckList
  },
  {
    path: '/recheckList1',
    name: 'recheckList1',
    component: recheckList1
  },
  {
    path: '/abnormalStudentList',
    name: 'abnormalStudentList',
    component: abnormalStudentList
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    next()
  } else if (!localStorage.getItem('token')) {
    next('/')
  } else {
    next()
  }
})

export default router
